module.exports = __webpack_public_path__ + "static/media/lang-ptBR.5131ffba.svg";